import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';

export class Amenity {
  id!: string;
  name!: string;
  icon!: string;
  description!: string;
  isSelected: boolean = false;
}

export class ProjectHighlight {
  amenityId!: string;
  amenityName!: string;
  content!: string;
}

@Component({
  selector: 'app-projecthighlights',
  templateUrl: './projecthighlights.component.html',
  styleUrls: ['./projecthighlights.component.css']
})
export class ProjecthighlightsComponent implements OnInit {
  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  
  selectedHighlights: Array<ProjectHighlight> = [];
  
  // Predefined amenities list
  amenitiesList: Array<Amenity> = [
    {
      id: 'swimming-pool',
      name: 'Swimming Pool',
      icon: 'ri-water-flash-line',
      description: 'Modern swimming pool facilities for residents',
      isSelected: false
    },
    {
      id: 'parking',
      name: 'Parking',
      icon: 'ri-car-line',
      description: 'Dedicated parking spaces for residents',
      isSelected: false
    },
    {
      id: 'gym',
      name: 'Gym/Fitness',
      icon: 'ri-briefcase-line',
      description: 'Fully equipped fitness center and gym',
      isSelected: false
    },
    {
      id: 'security',
      name: '24/7 Security',
      icon: 'ri-shield-check-line',
      description: '24/7 security with CCTV surveillance',
      isSelected: false
    },
    {
      id: 'garden',
      name: 'Garden & Park',
      icon: 'ri-leaf-line',
      description: 'Landscaped gardens and green spaces',
      isSelected: false
    },
    {
      id: 'library',
      name: 'Library',
      icon: 'ri-book-line',
      description: 'Community library and reading room',
      isSelected: false
    },
    {
      id: 'community',
      name: 'Community Center',
      icon: 'ri-home-community-line',
      description: 'Community center for social gatherings',
      isSelected: false
    },
    {
      id: 'solar',
      name: 'Solar Energy',
      icon: 'ri-sun-line',
      description: 'Solar panels for green energy',
      isSelected: false
    },
    {
      id: 'water',
      name: 'Water Treatment',
      icon: 'ri-water-percent-line',
      description: 'Advanced water purification system',
      isSelected: false
    },
    {
      id: 'kids',
      name: 'Kids Play Area',
      icon: 'ri-play-circle-line',
      description: 'Safe kids play area with games',
      isSelected: false
    }
  ];

  constructor(
    private lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.loadExistingHighlights();
  }

  loadExistingHighlights(): void {
    let property = this.lookupModel.getVendorProperty();
    if (property && property.projectHighlights) {
      this.selectedHighlights = property.projectHighlights;
      // Mark amenities as selected
      this.selectedHighlights.forEach(highlight => {
        const amenity = this.amenitiesList.find(a => a.id === highlight.amenityId);
        if (amenity) {
          amenity.isSelected = true;
        }
      });
    }
  }

  toggleAmenity(amenity: Amenity): void {
    amenity.isSelected = !amenity.isSelected;
    
    if (amenity.isSelected) {
      // Generate content and add to highlights
      const highlight = new ProjectHighlight();
      highlight.amenityId = amenity.id;
      highlight.amenityName = amenity.name;
      highlight.content = this.generateHighlightContent(amenity);
      this.selectedHighlights.push(highlight);
    } else {
      // Remove from highlights
      this.selectedHighlights = this.selectedHighlights.filter(h => h.amenityId !== amenity.id);
    }
  }

  generateHighlightContent(amenity: Amenity): string {
    const templates: { [key: string]: string } = {
      'swimming-pool': `Experience luxury living with our state-of-the-art swimming pool facilities. Perfect for lap swimming and recreational activities for the whole family.`,
      'parking': `Convenient and secure parking spaces for every resident. Well-maintained parking areas with modern security systems.`,
      'gym': `Stay fit and healthy with our fully equipped fitness center. Professional equipment and ample space for all your workout needs.`,
      'security': `Your safety is our priority. Round-the-clock security with CCTV surveillance, trained security personnel, and controlled access.`,
      'garden': `Serene landscaped gardens and well-maintained green spaces. Perfect for relaxation and outdoor activities.`,
      'library': `Quiet and peaceful community library stocked with a collection of books for residents to enjoy reading and learning.`,
      'community': `A vibrant community center designed for social gatherings, events, and fostering community bonds among residents.`,
      'solar': `Eco-friendly living with solar energy panels providing sustainable power solutions. Reduce carbon footprint and save on energy costs.`,
      'water': `Advanced water purification and treatment system ensures clean, safe drinking water for all residents.`,
      'kids': `Safe and well-designed kids play area equipped with games and activities. A perfect place for children to play and have fun.`
    };
    
    return templates[amenity.id] || amenity.description;
  }

  getAmenityIcon(amenityId: string): string {
    const amenity = this.amenitiesList.find(a => a.id === amenityId);
    return amenity ? amenity.icon : '';
  }

  back(): void {
    this.showNextPage.emit(5)
  }

  submit(): void {
    let property = this.lookupModel.getVendorProperty();
    property.projectHighlights = this.selectedHighlights;
    this.lookupModel.setVendorProperty(property);
    this.showNextPage.emit(7);
  }

}
